import * as React from 'react';
import { Route, Switch, withRouter } from 'react-router-dom';

import AdminActivitySidebar from './adminActivitySidebar';

import FillInBlankQuestionManager from '../fillInBlankActivities/fillInBlankQuestionManager';

const AdminActivity = () => {
  return (
    <div style={{display: 'flex', width: '100%'}}>
      <Switch>
        <Route component={AdminActivitySidebar} path='/admin/activity-view/:lessonID/fill-in-the-blanks/:questionID' />
      </Switch>
      <Switch>
        <Route component={FillInBlankQuestionManager} path='/admin/activity-view/:lessonID/fill-in-the-blanks/:questionID' />
      </Switch>
    </div>
  )
}

export default withRouter(AdminActivity);
